/**
 * External destinations the builder links out to (CT-5197).
 *
 * The Metabase base URL is per-workspace and there is no configured value yet,
 * so it is read from the environment and the escape hatch simply **does not
 * render** when it is unset. The alternative — hardcoding a plausible host — is
 * the one thing CT-5197 rules out, and a dead link is worse than no link.
 *
 * TODO(CT-5183 / backend): serve the workspace's Metabase URL alongside the
 * workspace settings and read it from there instead of an env var.
 */
const RAW_METABASE_URL = import.meta.env?.VITE_METABASE_BASE_URL ?? '';

/** Metabase URL, or `null` when the workspace has none configured. */
export const metabaseUrl = () => {
  const trimmed = String(RAW_METABASE_URL).trim();
  return trimmed.length > 0 ? trimmed : null;
};

export default metabaseUrl;
